<section class="Experts">
  <div class="experts-big-text">
    <p>
      <span class="highlight">{{ "policy.header.highlight" | translate }}</span
      >{{ "policy.header.title1" | translate }}<br class="mob-br" />
      {{ "policy.header.title2" | translate
      }}<span class="captional-text">{{
        "policy.header.bold" | translate
      }}</span>
    </p>
  </div>
  <div class="experts-text">
    <span class="additional-inf">
      {{ "policy.header.subtitle" | translate }}
    </span>
    <p>
      <span class="rectangle"></span>{{ "policy.header.text1" | translate }}
    </p>
    <p>
      <span class="rectangle"></span>{{ "policy.header.text2" | translate }}
    </p>
    <p>
      <span class="rectangle"></span>{{ "policy.header.text3" | translate }}
    </p>
    <p>
      <span class="rectangle"></span>{{ "policy.header.text4" | translate }}
    </p>
  </div>
</section>

<section class="about-us">
  <article class="article-who">
    <div class="experts-text">
      <div class="mobile-element-exp"></div>
      <h2>
        {{ "about.about.title5" | translate }}
        <hr />
      </h2>
    </div>
    <div class="experts-description-text">
      <p>
        {{ "about.about.subtitle5" | translate }}
      </p>
      <p>
        {{ "about.about.subtitle5A" | translate }}
      </p>
    </div>
    <a target="_blank" href="assets/pdf/kodeks_etyczny.pdf"
      ><button class="experts-btn wrtie-to-us">
        {{ "about.about.button5" | translate }} →
      </button></a
    >
  </article>

  <section class="exp-elements">
    <div class="row-elements">
      <div class="first-element"></div>
      <div id="element-anim" class="second-element"></div>
    </div>
    <div class="col-elements">
      <div class="third-element"></div>
      <div class="fourth-element"></div>
    </div>
  </section>
</section>

<section class="our-ekologic">
  <div class="test">
    <aside></aside>
    <article></article>
  </div>

  <div class="parent">
    <div class="div1">
      {{ "policy.numbers.title1" | translate }}<br />{{
        "policy.numbers.title2" | translate
      }}
      <hr />
    </div>
    <div class="div2">50 %</div>
    <div class="div3">30 %</div>
    <div class="div4">100 %</div>
    <div class="div5">
      <p>
        <span>{{ "policy.numbers.subtitle1" | translate }}</span
        ><br />{{ "policy.numbers.text1" | translate }}
      </p>
    </div>
    <div class="div6">
      <p>
        <span>{{ "policy.numbers.subtitle2" | translate }}</span
        ><br />{{ "policy.numbers.text2" | translate }}
      </p>
    </div>
    <div class="div7">
      <p>
        <span>{{ "policy.numbers.subtitle3" | translate }}</span
        >{{ "policy.numbers.text3" | translate }}<br />{{
          "policy.numbers.text4" | translate
        }}
      </p>
    </div>
  </div>
</section>

<!-- SECTION OUR EKOLOGIC FOR MOBILE-->
<section class="mobile-our-ekologic">
  <div class="test">
    <aside></aside>
    <article></article>
  </div>
  <div class="mobile-parent">
    <div class="mobile-div1">
      <div class="mobile-ele">
        {{ "policy.numbers.mobileTitle" | translate }}
      </div>
      <hr />
    </div>
    <div class="mobile-div2"><div class="mob-ele">50 %</div></div>
    <div class="mobile-div3">
      <div class="mob-ele">
        <p>
          <span>{{ "policy.numbers.subtitle1" | translate }}</span
          ><br />{{ "policy.numbers.text1" | translate }}
        </p>
      </div>
    </div>
    <div class="mobile-div4">30 %</div>
    <div class="mobile-div5">
      <p>
        <span>{{ "policy.numbers.subtitle2" | translate }}</span
        ><br />{{ "policy.numbers.text2" | translate }}
      </p>
    </div>
    <div class="mobile-div6"><div class="mob-ele">100 %</div></div>
    <div class="mobile-div7">
      <div class="mob-ele">
        <p>
          <span>{{ "policy.numbers.subtitle3" | translate }}</span
          >{{ "policy.numbers.text3" | translate }}<br />{{
            "policy.numbers.text4" | translate
          }}
        </p>
      </div>
    </div>
  </div>
</section>
<!-- *** -->

<section class="contact-us">
  <div class="hero">
    <span
      ><span class="highlight"
        >{{ "policy.target.title" | translate }}<br /></span
      ><span class="text-thin"
        >{{ "policy.target.subtitle1" | translate }}<br class="con-br" />
        {{ "policy.target.subtitle2" | translate }}</span
      ><span class="captional-text"
        >{{ "policy.target.subtitle3" | translate }}<br class="mob-br" /></span
    ></span>
    <hr />
    <p>
      {{ "policy.target.text1" | translate }}<span class="rectangle"></span
      >{{ "policy.target.text2" | translate }} <span class="rectangle"></span
      >{{ "policy.target.text3" | translate }}
    </p>

    <button
      routerLink="/contact"
      routerLinkActive="active"
      class="contact"
      id="btn-con"
    >
      {{ "policy.target.button" | translate }} →
    </button>
  </div>
</section>
